<template>
<b-container fluid>
  <br>
  <h1>Password Reset</h1>
  <b-row class="justify-content-md-center">
    <b-col lg="4" sm="8" md="6">
      <b-form v-on:submit.prevent="requestReset">
          <b-form-group
      id="fieldset-1"
      label="Email"
      label-align="left"
      label-for="email-id"
    >
    <b-form-input id="email-id" v-model="email" type="email" aria-describedby="email-help-block"></b-form-input>
          </b-form-group>

   <b-button id="submit-id" type="submit" block variant="outline-primary">Submit</b-button>
      </b-form>

    </b-col>
  </b-row>
</b-container>
</template>

<script>
  import axios from 'axios'
    export default {
        name: "PasswordReset.vue",
        data() {
            return {
                email: '',
            }
        },
        methods: {

            requestReset() {
                axios.post('/api/account/reset/',{email:this.email.toLowerCase()}).then(response => {
                    if (response.data.status == 'received'){
                 this.$router.push({name: 'gallery', query: {a: 'resetemail'}})
                }
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PasswordResetRequest.vue